import { Autocomplete, TextField } from "@mui/material";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import type { CompanyInfo } from "../../api/clientsManagementTypes";

interface Props {
  companies: CompanyInfo[];
  value: CompanyInfo | null;
  onChange: (company: CompanyInfo | null) => void;
  validationResult?: ValidationResult;
}

const OrganizationCompanySelector = ({ companies, value, onChange, validationResult }: Props) => {
  return (
    <Autocomplete
      fullWidth
      options={companies}
      value={value}
      onChange={(_, value) => onChange(value)}
      getOptionLabel={(option) => `${option.name} - ${option.clientCode}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Company"
          error={validationResult?.isValid === false}
          helperText={validationResult?.error}
        />
      )}
    />
  );
};

export default OrganizationCompanySelector;
